<!-- 创建时间2023/07/04 14:50:58 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div class="yxtbiz-kng-point__cell mb12">
    <template v-if="isEdit">
      <form-point-form :form="temp" insert-hidden/>
      <div class="mt20">
        <yxt-button type="second" :disabled="!temp.time || !temp.desc" @click="save">{{ $t('pc_save'/** 保存 */) }}</yxt-button>
        <yxt-button @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
      </div>
    </template>
    <div v-else class="yxtbiz-flex">
      <div>{{ getDurationFormat(cellData.markTime) }}</div>
      <div class="ml16 break yxtbiz-flex-1">
        {{ cellData.markDesc }}
      </div>
      <yxt-svg @click.native="edit" class="ml16 hand" width="16px" height="16px" icon-class="common_edit"/>
      <yxt-svg @click.native="del" class="ml12 hand" width="16px" height="16px" icon-class="common_delete"/>
    </div>
  </div>
</template>

<script>
import { getDurationFormat } from 'yxt-biz-pc/packages/kng-operator/utils';
import formPointForm from './form-point-form';
export default {
  name: 'form-point-cell',
  components: {
    formPointForm
  },
  props: {
    cellData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      temp: {}
    };
  },
  methods: {
    getDurationFormat,
    edit() {
      const {markTime, markDesc} = this.cellData;
      this.temp = {time: markTime, desc: markDesc};
      this.$emit('change', this.cellData);
    },
    del() {
      this.$emit('delete', this.cellData);
    },
    save() {
      this.cellData.markTime = this.temp.time;
      this.cellData.markDesc = this.temp.desc;
      this.$emit('save', this.cellData);
      this.$emit('change', null);
    },
    cancel() {
      this.$emit('change', null);
    }
  }
};
</script>